export const HYPERDX_API_KEY = '244374a3-6e98-4f2e-bac4-ed77afc970d5';
